import {
  ADD_LABREQUESTSAMPLE_FAIL,
  ADD_LABREQUESTSAMPLE_SUCCESS,
  ADD_LABREQUESTSAMPLECONTROL_FAIL,
  ADD_LABREQUESTSAMPLECONTROL_SUCCESS,
  ADD_LABREQUESTSAMPLEPROCESS_FAIL,
  ADD_LABREQUESTSAMPLEPROCESS_SUCCESS,
  ADD_NEW_LABREQUESTSAMPLE,
  ADD_NEW_LABREQUESTSAMPLECONTROL,
  ADD_NEW_LABREQUESTSAMPLEPROCESS,
  DELETE_LABREQUESTSAMPLE,
  DELETE_LABREQUESTSAMPLE_FAIL,
  DELETE_LABREQUESTSAMPLE_SUCCESS,
  GET_LABREQUESTSAMPLE,
  GET_LABREQUESTSAMPLE_FAIL,
  GET_LABREQUESTSAMPLE_SUCCESS,
  GET_LABREQUESTSAMPLES,
  GET_LABREQUESTSAMPLES_FAIL,
  GET_LABREQUESTSAMPLES_SUCCESS,
  SET_STATE_LABREQUESTSAMPLE,
  UPDATE_LABREQUESTSAMPLE,
  UPDATE_LABREQUESTSAMPLE_FAIL,
  UPDATE_LABREQUESTSAMPLE_SUCCESS,
  UPDATE_LABREQUESTSAMPLECHECK,
  MASSIVE_SAMPLE_STATUS_UPDATE,
  MASSIVE_SAMPLE_STATUS_UPDATE_SUCCESS,
  MASSIVE_SAMPLE_STATUS_UPDATE_FAIL,
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTSAMPLE,
  payload: loading,
})

export const getLabRequestSamples = ( params ) => ({
  type: GET_LABREQUESTSAMPLES,
  payload: { params },
})

export const getLabRequestSamplesSuccess = (labRequestSamples, totalPages, currentPage) => ({
  type: GET_LABREQUESTSAMPLES_SUCCESS,
  payload: { labRequestSamples:labRequestSamples, total:totalPages, currentPage:currentPage}
})

export const getLabRequestSamplesFail = error => ({
  type: GET_LABREQUESTSAMPLES_FAIL,
  payload: error,
})

export const addNewLabRequestSample = labRequestSample => ({
  type: ADD_NEW_LABREQUESTSAMPLE,
  payload: labRequestSample,
})

export const addLabRequestSampleSuccess = labRequestSample => ({
  type: ADD_LABREQUESTSAMPLE_SUCCESS,
  payload: labRequestSample,
})  

export const addLabRequestSampleFail = error => ({
  type: ADD_LABREQUESTSAMPLE_FAIL,
  payload: error,
})

export const addNewLabRequestSampleProcess = labRequestSample => ({
  type: ADD_NEW_LABREQUESTSAMPLEPROCESS,
  payload: labRequestSample,
})

export const addLabRequestSampleProcessSuccess = labRequestSample => ({
  type: ADD_LABREQUESTSAMPLEPROCESS_SUCCESS,
  payload: labRequestSample,
})  

export const addLabRequestSampleProcessFail = error => ({
  type: ADD_LABREQUESTSAMPLEPROCESS_FAIL,
  payload: error,
})

export const addNewLabRequestSampleControl = labRequestSample => ({
  type: ADD_NEW_LABREQUESTSAMPLECONTROL,
  payload: labRequestSample,
})

export const addLabRequestSampleControlSuccess = id => ({
  type: ADD_LABREQUESTSAMPLECONTROL_SUCCESS,
  payload: { id:id},
})  

export const addLabRequestSampleControlFail = error => ({
  type: ADD_LABREQUESTSAMPLECONTROL_FAIL,
  payload: error,
})

export const updateLabRequestSample = labRequestSample => ({
  type: UPDATE_LABREQUESTSAMPLE,
  payload: labRequestSample,
})

export const updateLabRequestSampleSuccess = labRequestSample => ({
  type: UPDATE_LABREQUESTSAMPLE_SUCCESS,
  payload: labRequestSample,
})

export const updateLabRequestSampleFail = error => ({
  type: UPDATE_LABREQUESTSAMPLE_FAIL,
  payload: error,
})

export const updateLabRequestSampleCheck = (id, checkValue) => ({
  type: UPDATE_LABREQUESTSAMPLECHECK,
  payload: { id:id, checked:checkValue },
})

export const massiveSampleStatusUpdate = (labRequestId, validationValues) => ({
  type: MASSIVE_SAMPLE_STATUS_UPDATE,
  payload: { labRequestId, validationValues },
});

export const massiveSampleStatusUpdateSuccess = () => ({
  type: MASSIVE_SAMPLE_STATUS_UPDATE_SUCCESS,
});

export const massiveSampleStatusUpdateFail = error => ({
  type: MASSIVE_SAMPLE_STATUS_UPDATE_FAIL,
  payload: error,
});

export const deleteLabRequestSample = labRequestSample => ({
  type: DELETE_LABREQUESTSAMPLE,
  payload: labRequestSample,
})

export const deleteLabRequestSampleSuccess = id => ({
  type: DELETE_LABREQUESTSAMPLE_SUCCESS,
  id,
})

export const deleteLabRequestSampleFail = error => ({
  type: DELETE_LABREQUESTSAMPLE_FAIL,
  payload: error,
})

export const getLabRequestSample = ( params ) => ({
  type: GET_LABREQUESTSAMPLE,
  payload: { params },
})

export const getLabRequestSampleSuccess = labRequestSample => ({
  type: GET_LABREQUESTSAMPLE_SUCCESS,
  payload: labRequestSample,
})

export const getLabRequestSampleFail = error => ({
  type: GET_LABREQUESTSAMPLE_FAIL,
  payload: error,
})
